import Constant from '@/common/constant/Constant';
// import Utils from '@/common/utils/utils';
import { Button, Dialog, DialogActions, DialogContent } from '@material-ui/core';
import { I18n } from 'aws-amplify';

export const DialogConfirmSoftDeleteTicket = props => {
    const { isOpen, setIsOpen, detailTicket } = props;

    // const statusDetail = Utils.convertJSONDataToObject(detailTicket?.statusDetail);
    // const currentStatus = statusDetail?.structure?.no;
    let messageStatus = I18n.get('MSG-CM-CONFIRM-DELETE-CONTENT-ON-TICKET-LIST');
    // if (
    //     currentStatus === Constant.STATUS_NO.WAITING ||
    //     Constant.STATUS_NO.DOING ||
    //     Constant.STATUS_NO.PENDING ||
    //     Constant.STATUS_NO.TODO ||
    //     detailTicket?.public === Constant.TICKET_PUBLIC.DRAFT
    // ) {
    //     messageStatus = I18n.get('COMMSG059');
    // }

    if (
        // currentStatus === Constant.STATUS_NO.DONE ||
        detailTicket?.liveOrArchived === Constant.LIVE_OR_ARCHIVED.ARCHIVED
        // Utils.isAnonymousQATicketFromLiveChat(detailTicket)
    ) {
        messageStatus = I18n.get('MSG-CM-CONFIRM-DELETE-CONTENT');
    }

    // if (detailTicket?.listTicketChild || detailTicket?.parent) {
    //     messageStatus = I18n.get('COMMSG053');
    // }

    // if ([Constant.TICKET_TYPE.TASK, Constant.TICKET_TYPE.EMAIL].includes(detailTicket?.ticketType)) {
    //     messageStatus = I18n.get('MSG-CM-CONFIRM-DELETE-LOGIC-CONTENT-1');
    //     if (detailTicket?.liveOrArchived === Constant.LIVE_OR_ARCHIVED.ARCHIVED || currentStatus === Constant.STATUS_NO.DONE) {
    //         messageStatus = I18n.get('MSG-CM-CONFIRM-DELETE-LOGIC-CONTENT-2');
    //     }
    // }

    const onCloseConfirm = (event, reason) => {
        if (event && reason === 'backdropClick') {
            return false;
        }
        setIsOpen(false);
    };

    const onSubmitSoftDelete = () => {
        props.submitSoftDelete();
        setIsOpen(false);
    };

    return (
        <Dialog
            open={isOpen}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="wrapDialog"
        >
            <DialogContent>
                <div className="confirmPlease">
                    {messageStatus}
                </div>
            </DialogContent>
            <DialogActions className="confirm-dialog-action">
                <Button
                    variant="contained"
                    className="btn-hg32 btn-handle-delete-user-agree btn-handle-delete-user-agree-important"
                    onClick={onSubmitSoftDelete}
                >
                    {I18n.get('CM-BUTTON-OK')}
                </Button>
                <Button
                    variant="contained"
                    className="btn-light btn-hg32"
                    onClick={(event, reason) => onCloseConfirm(event, reason)}
                >
                    {I18n.get('CM-BUTTON-CANCEL')}
                </Button>
            </DialogActions>
        </Dialog>
    );
};
